import { Component } from '@angular/core'
import { CmsNavigationComponent } from '@spartacus/core'
import { CmsComponentData, FooterNavigationComponent, NavigationService } from '@spartacus/storefront'

@Component({
    selector: 'app-custom-footer-navigation',
    templateUrl: './custom-footer-navigation.component.html',
    styleUrls: ['./custom-footer-navigation.component.scss'],
    standalone: false
})
export class CustomFooterNavigationComponent extends FooterNavigationComponent {
  constructor(
    protected componentData: CmsComponentData<CmsNavigationComponent>,
    protected service: NavigationService
  ) {
    super(componentData, service)
  }
}
